import type { DevicePlatform } from "./platform";

/** Что с уведомлениями на этом устройстве — одной фразой для человека. */
export function pushStatusLabel(
  permission: NotificationPermission | "unsupported",
  subscribed: boolean,
  installed: boolean,
  platform: DevicePlatform | null,
): string {
  if (permission === "unsupported") {
    return platform === "ios" && !installed
      ? "На iPhone и iPad уведомления работают только в установленном приложении. Установите ERP на экран «Домой»."
      : "Этот браузер не умеет показывать уведомления при закрытой вкладке.";
  }
  if (permission === "denied") {
    return "Заблокированы в настройках браузера. Разрешите их для этого сайта и подключите устройство заново.";
  }
  if (permission === "granted") {
    return subscribed
      ? "Включены: уведомления приходят на это устройство, даже когда ERP закрыта."
      : "Браузер разрешил уведомления, но это устройство ещё не подключено.";
  }

  return "Не включены. Разрешение будет запрошено при подключении устройства.";
}
